import React from 'react';
import moment from 'moment';
import TimerIcon from '@mui/icons-material/Timer';
import { timeConverter } from 'utils/helpers';
import NoDataMsg from 'library/noData';


const Body = (props) => (
    <React.Fragment>
        {
            props.employees.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                props.employees.length > 0 ?
                    <div>
                        {/* Table to display each day of the Date Range Selected */}
                        <div className="text-center list_header">
                            {props.beginDate ?
                                <p><i>From</i> <b>{moment(props.beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                    {
                                        props.endDate ? <b>{moment(props.endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                : ""}
                        </div>

                        <div className="table-responsive mt-2 pl-2 pr-2">
                            {
                                props.employees.map((item, index) => {
                                    return (
                                        <div className="row m-0 mb-2 price_info border_bottom_grey" key={index}>
                                            <div className="col-lg-7 col-md-7 col-sm-6 col-xs-12 m-0 p-0 pl-2" >
                                                <h4>{item.employeeName}</h4>
                                                {/* <p>
                                        <i>{item.title}</i>
                                    </p> */}
                                            </div>
                                            <div className="col-lg-5 col-md-5 col-sm-6 col-xs-12 m-0 p-0 pb-2" >
                                                <div className="row m-0">
                                                    <div className="col-lg-2 m-0 p-0 text-right pr-2">
                                                        <span className="table_icon"><TimerIcon /></span>
                                                    </div>
                                                    <div className="col-lg-10 m-0 p-0">
                                                        <label className=""><i>Total Hours:</i></label>
                                                        <h4 className="grey-text">{timeConverter(item.totalMinutes)}</h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    );
                                })
                            }
                        </div>
                    </div> : ''
        }
    </React.Fragment>
)

export default Body;